import { ShellCommand } from './commands/shell.command';

export const RESET_COMMANDS = [
  new ShellCommand('pm uninstall com.Oculera.perimetryVR20'),
  new ShellCommand('pm uninstall fr.eyesoft.app'),
  new ShellCommand('pm uninstall fr.eyesoft.updateapp'),
  new ShellCommand('pm uninstall fr.eyesoft.krys.app'),
  new ShellCommand('pm uninstall fr.eyesoft.krys.updateapp'),
  new ShellCommand('pm uninstall fr.eyesoft.lenscapeapp'),
  new ShellCommand('pm uninstall fr.eyesoft.updatelenscapeapp'),
  new ShellCommand('pm uninstall fr.eyesoft.evosight.app'),
  new ShellCommand('pm uninstall fr.eyesoft.visionlab.app'),
  new ShellCommand('pm uninstall fr.eyesoft.lenscape.app'),
  new ShellCommand('pm uninstall fr.eyesoft.updater.app'),
  new ShellCommand('pm uninstall fr.eyesoft.check.app'),
  new ShellCommand('pm uninstall fr.eyesoft.optic.app'),
  new ShellCommand('rm /storage/self/primary/Android/data/fr.eyesoft.config.patient'),
  new ShellCommand('rm /storage/emulated/0/Android/data/fr.eyesoft.krys.app/files/settings.json'),
  new ShellCommand("setprop persist.pxr.force.home ''"),
  new ShellCommand('rm /sdcard/config.txt'),
  new ShellCommand('rm /sdcard/SeethroughSetting/Config/Config1.txt'),
];
